import { render, staticRenderFns } from "./teamManage.vue?vue&type=template&id=054d2399"
import script from "./teamManage.vue?vue&type=script&lang=js"
export * from "./teamManage.vue?vue&type=script&lang=js"
import style0 from "./teamManage.vue?vue&type=style&index=0&id=054d2399&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports